import { Box, CircularProgress, Typography } from "@mui/material";

const PageLoader = ({ loading, message, fullHeight = false}) => {
    if (!loading) return null;

    return(
        <Box sx={{
            display: "flex",
            flexDirection: "column", 
            justifyContent: "center",
            alignItems: "center",
            height: fullHeight ? "100vh" : "50vh",
            gap: 2,
            color: "text.secondary",
        }}>
            <CircularProgress />
            {message && (
                <Typography variant="body2" color="text.secondary">{message}</Typography>
            )}
        </Box>
    );
};

export default PageLoader;